import React from "react";
import { connect } from "react-redux";
import __ from "lodash";
import { cekCookies } from "../../../../actions";
import { CONFIG } from "../../../../config";
import { Row, Col } from "react-bootstrap";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import LoaderModal from "../../../modal/LoaderModal";

import accountManagement from "../../../../apis/accountManagement";
import filterReportDinasAgcu from "../../../../entity/FilterReportDinasAgcu";
import KelasSearch from "../../../../entity/KelasSearch";
import DropdownKelas from "../masterDropDown/DropdownKelas";
import DropdownProfilCbtDinas from "../masterDropDown/DropdownProfilCbtDinas";
import ReportAgcuDetail from "./ReportAgcuDetail";
import DropdownTahunAjaran from "../masterDropDown/DropdownTahunAjaran";
// import './report-custom.css';

class ReportDinasAgcu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            showAlert: false,
            resMessage: null,
            idAdmin: null,
            idProvinsi: null,
            idDinas: null,
            namaDinas: null,
            kelas: [],
            idKelas: null,
            profilCbt: [],
            idProfilCbt: null,
            typeReport: "AGCU",
            namaProfilCbtSelected: null,
            dataMapel: [],
            dataRataStatistik: [],
            dataRataSekolah: [],
            dataRataPerSekolah: [],
            dataSekolahDinas: [],
            dataLS: [],
            dataPSI: [],
            result: [],
            dataSatuanPend: null,
            dataJumAllSiswa: null,
            tahunAjaran: [],
            kodeTahunAjaran: null,
        };
    }

    async componentDidMount() {
        document.title = "Report Dinas AGCU";
        console.time("Time componentDidMount");
        this.setState({
            isFetching: true,
        });
        await this.props.cekCookies();

        console.groupCollapsed("componentDidMount");
        console.log("CEK ACCOUNT", this.props.account);
        console.groupEnd();

        if (!__.isEmpty(this.props.account)) {
            this.fetchTa();
            this.setState({
                idAdmin: this.props.account.idAdmin,
                idProvinsi: this.props.account.idProvinsi,
                idDinas: this.props.account.idDinas,
                namaDinas: this.props.account.namaUser,
            });

            // Fetch Kelas
            const responseFetchKelas = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, { KelasSearch, kodeJenjangSekolah: null }).catch(function (error) {
                console.log("ERROR ACCOUNT_MANAGEMENT_SEARCH_KELAS", error);
            });

            // Set State Kelas
            if (responseFetchKelas.request.readyState === 4 && responseFetchKelas.status === 200) {
                console.log("CEK KELAS", responseFetchKelas);
                if (responseFetchKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        kelas: responseFetchKelas.data.data,
                    });
                }
            }
        }

        window.$("#sidebar").mCustomScrollbar({
            theme: "minimal",
        });

        window.$("#sidebarCollapse").on("click", function () {
            window.$("#sidebar, #content").toggleClass("active");
            window.$(".collapse.in").toggleClass("in");
            window.$("a[aria-expanded=true]").attr("aria-expanded", "false");
        });

        this.setState({
            isFetching: false,
        });
        console.timeEnd("Time componentDidMount");
    }

    fetchTa = async () => {
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function (error) {});
        if (resTa) {
            if (resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    tahunAjaran: resTa.data.data,
                });
            }
        }

        resTa.data.data.map((val) => {
            if (val.status === "1") {
                this.setState({ kodeTahunAjaran: val.kodeTahunAjaran });
            }
        });
    };

    handleOnChangeTahunAjaran = async (ta) => {
        this.setState({
            kodeTahunAjaran: ta.target.value,
        });
    };

    onChangeKelas = async (event) => {
        console.clear();
        console.time("Time onChangeKelas");
        this.setState({
            isFetching: true,
        });
        const fieldName = event.target.name;
        const fieldValue = event.target.value;

        console.groupCollapsed("CEK KELAS TERPILIH");
        console.log("fieldName", fieldName);
        console.log("fieldValue", fieldValue);
        console.groupEnd();

        this.setState({
            profilCbt: [],
            idProfilCbt: null,
            namaProfilCbtSelected: null,
            [fieldName]: fieldValue,
        });

        // Fetch Profil
        const responseFetchProfil = await accountManagement.get(CONFIG.REPORT_DINAS_AGCU_PROFIL + fieldValue).catch(function (error) {
            console.log("ERROR REPORT_DINAS_AGCU_PROFIL", error);
        });
        console.log("CEK PROFIL", responseFetchProfil);

        // Set State Profil
        if (responseFetchProfil.request.readyState === 4 && responseFetchProfil.status === 200) {
            if (responseFetchProfil.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    profilCbt: responseFetchProfil.data.data.jadwalCbt,
                    isFetching: false,
                });
            }
        }
        console.timeEnd("Time onChangeKelas");
    };

    onChangeProfil(event) {
        console.clear();
        console.time("Time onChangeProfil");
        this.setState({
            isFetching: true,
        });
        let index = event.nativeEvent.target.selectedIndex;
        let label = event.nativeEvent.target[index].text;
        const fieldName = event.target.name;
        const fieldValue = event.target.value;

        console.groupCollapsed("CEK PROFIL TERPILIH");
        console.log("index", index);
        console.log("label", label);
        console.log("fieldName", fieldName);
        console.log("fieldValue", fieldValue);
        console.groupEnd();

        this.setState({
            [fieldName]: fieldValue,
            namaProfilCbtSelected: label,
            isFetching: false,
        });
        console.timeEnd("Time onChangeProfil");
    }

    showReportDinasAgcu = async () => {
        console.clear();
        console.time("Time showReportDinasAgcu");
        this.setState({
            isFetching: true,
        });
        console.groupCollapsed("PREVIEW REPORT AGCU");
        console.log(this.state.idKelas);
        console.log(this.state.idProfilCbt);

        // Fetch Report
        // const result = await accountManagement.post(CONFIG.REPORT_DINAS_AGCU_LIST, {...filterReportDinasAgcu,
        const result = await accountManagement.post(CONFIG.REPORT_DINAS_AGCU_NEW_LIST, { ...filterReportDinasAgcu, idKelas: this.state.idKelas, idProfilCbt: this.state.idProfilCbt, typeReport: this.state.typeReport }).catch(function (error) {
            console.log("ERROR REPORT_DINAS_AGCU_LIST", error);
        });

        if (result) {
            if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    // result: result.data.data,
                    dataMapel: result.data.data.mapel,
                    dataRataStatistik: result.data.data.rataStatistik,
                    dataRataSekolah: result.data.data.rataSekolah,
                    dataRataPerSekolah: result.data.data.rataPerSekolah,
                    dataSekolahDinas: result.data.data.sekolahDinas,
                    dataSatuanPend: result.data.data.satuanPendidikan,
                    dataJumAllSiswa: result.data.data.jumAllSiswa,
                    dataLS: result.data.data.LS,
                    dataPSI: result.data.data.PSI,
                    dataDominasiLS: result.data.data.dominasiLS,
                    isFetching: false,
                });
            } else {
                this.setState({
                    showAlert: true,
                    resMessage: result.data.errorSchema.errorMessage,
                    isFetching: false,
                });
            }
        }
        console.groupEnd();
        console.timeEnd("Time showReportDinasAgcu");
    };

    handleReport = async () => {
        console.clear();

        console.log("====================================");
        console.log("kodeTa", this.state.kodeTahunAjaran);
        console.log("idProfilCbt", this.state.idProfilCbt);
        console.log("====================================");

        this.setState({
            kodeTahunAjaran: this.state.kodeTahunAjaran,
            idProfilCbt: this.state.idProfilCbt,
        });

        window.open("report_dinas_agcu/" + this.state.kodeTahunAjaran + "/" + this.state.idProfilCbt, "_blank");
    };

    render() {
        console.groupCollapsed("Render Cek State/Props ReportDinasAgcu");
        console.log("STATE", this.state);
        console.log("PROPS", this.props);
        console.groupEnd();

        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />

                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar />

                    <Row>
                        <Col sm={3}>
                            <select className="form-control" value={this.state.kodeTahunAjaran} onChange={this.handleOnChangeTahunAjaran} required>
                                <option value="" selected disabled>
                                    ~~ Pilih Tahun Ajaran ~~
                                </option>
                                <DropdownTahunAjaran tahunAjaran={this.state.tahunAjaran} />
                            </select>
                        </Col>

                        <Col sm={3}>
                            <select className="form-control" name="idKelas" id="idKelas" value={this.state.idKelas === null ? "" : this.state.idKelas} onChange={this.onChangeKelas.bind(this)} required>
                                <option value="" selected disabled>
                                    ~~ Pilih Kelas ~~
                                </option>
                                <DropdownKelas kelas={this.state.kelas} />
                            </select>
                        </Col>

                        <Col sm={4}>
                            <select className="form-control" name="idProfilCbt" id="idProfilCbt" value={this.state.idProfilCbt === null ? "" : this.state.idProfilCbt} onChange={this.onChangeProfil.bind(this)} required>
                                <option value="" selected>
                                    ~~ Pilih Profil AGCU ~~
                                </option>
                                <DropdownProfilCbtDinas profil={this.state.profilCbt} />
                            </select>
                        </Col>

                        {this.state.idKelas && this.state.idProfilCbt && (
                            <Col sm={2} className="text-right">
                                <button className="btn btn-primary btn-sm" onClick={this.showReportDinasAgcu}>
                                    <i className="fa fa-search"></i>&nbsp; Lihat
                                </button>
                                &nbsp;
                                <button className="btn btn-primary btn-sm" title="REPORT PDF" onClick={this.handleReport}>
                                    <i className="fa fa-file-pdf-o"></i>&nbsp; Report
                                </button>
                                {/* <button className="btn btn-primary" title="REPORT PDF" onClick={() => window.open("reportdinasagcu/" + this.state.idKelas + "/" + this.state.idProfilCbt + "/" + this.state.typeReport, "_blank")}></button> */}
                            </Col>
                        )}
                    </Row>

                    <Row style={{ paddingTop: "50px" }}>
                        <Col sm={12}>
                            <ReportAgcuDetail
                                namaDinas={this.state.namaDinas}
                                dataMapel={this.state.dataMapel}
                                sekolahDinas={this.state.dataSekolahDinas}
                                rataPerSekolah={this.state.dataRataPerSekolah}
                                rataSekolah={this.state.dataRataSekolah}
                                satuanPendidikan={this.state.dataSatuanPend}
                                jumAllSiswa={this.state.dataJumAllSiswa}
                                rataStatistik={this.state.dataRataStatistik}
                                pemataanLS={this.state.dataLS}
                                dominasiLS={this.state.dataDominasiLS}
                                pemetaanPSI={this.state.dataPSI}
                                namaProfilCbt={this.state.namaProfilCbtSelected}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(ReportDinasAgcu);
